import Schema, { required } from 'AppReact/schema';

const infoBox = { ytd: required('string'), mtd: required('string'), title: required('string') };

export default {
  infoBox: Schema(infoBox, 'object', { defaultValue: { title: '', ytd: '', mtd: '' } }),
  isytd: Schema('boolean', 'primitive', { defaultValue: false })
}